function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useMemo } from "react";
import { AdobeTarget } from "../AdobeTarget";
import analytics, { EventNames } from "../../../analytics";
import { composeDataMethods } from "@lululemon/mwa-utils";
import { mboxCache } from "./mboxes";
import useURL, { getURL } from "../../../hooks/useURL";
import { subscribe } from "../../../utils/pubsub";
import { getRemoteModule } from "../../../globalScriptProviders/remotes";
import logger, { LapelError } from "../../../logger";
import config from "../../../config";
var addGlobalMboxesToCache = function(cache) {
    var _config_mboxes = config().mboxes, maxGlobalCount = _config_mboxes.maxGlobalCount, maxLapelGlobalCount = _config_mboxes.maxLapelGlobalCount;
    var globals = {
        "lapel-global": maxLapelGlobalCount,
        "peps-global": maxGlobalCount
    };
    Object.keys(globals).forEach(function(key) {
        var count = globals[key];
        for(var i = 0; i < count; i++){
            cache.add({
                name: key + "-" + i
            });
        }
    });
};
var GlobalMboxes = function(param) {
    var children = param.children;
    var mboxes = useMemo(function() {
        var _config_mboxes = config().mboxes, maxGlobalCount = _config_mboxes.maxGlobalCount, maxLapelGlobalCount = _config_mboxes.maxLapelGlobalCount;
        var globals = {
            "lapel-global": maxLapelGlobalCount,
            "peps-global": maxGlobalCount
        };
        return Object.keys(globals).map(function(key) {
            var count = globals[key];
            return Array.from({
                length: count
            }, function(_, i) {
                return /*#__PURE__*/ _jsx(AdobeTarget, {
                    name: key + "-" + i
                }, key + "-" + i);
            });
        });
    }, []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            mboxes,
            children
        ]
    });
};
export function urlMatch(pattern, url) {
    if (pattern === url) {
        return true;
    }
    if (pattern === "*") {
        return true;
    }
    if (pattern.startsWith("regex:")) {
        return new RegExp(pattern.substring(6), "i").test(url);
    }
    var escapedPattern = pattern.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&").replace(/\\\*/g, ".*");
    var regex = new RegExp("^" + escapedPattern + "$", "i");
    return regex.test(url);
}
export var useMboxManifest = function(mboxes) {
    // In this case it's an array of mbox configurations
    // [{ name, parameters, profileParameters }, ...]
    useEffect(function() {
        Promise.resolve(mboxes).then(function(mboxes) {
            analytics.track(EventNames.MBOX_MANIFEST_USED, {
                mboxes: mboxes.map(function(mbox) {
                    return mbox.name;
                }),
                url: getURL()
            });
        });
        var un = subscribe("mbox-cache@execute-begin", /*#__PURE__*/ _async_to_generator(function() {
            var mboxesToAdd, err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            mboxes
                        ];
                    case 1:
                        mboxesToAdd = _state.sent();
                        if (Array.isArray(mboxesToAdd)) {
                            mboxesToAdd.forEach(function(mbox) {
                                mboxCache.add(mbox);
                            });
                        }
                        addGlobalMboxesToCache(mboxCache);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        logger.error(new LapelError("" + err.message + " when trying to get manifest mboxes", {
                            cause: err
                        }));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        }));
        mboxCache.execute();
        return function() {
            return un();
        };
    }, [
        mboxes
    ]);
};
export var withMboxManifest = function(mboxes) {
    return function(Component) {
        var WithMboxManifest = function(props) {
            useMboxManifest(mboxes);
            return /*#__PURE__*/ _jsx(Component, _extends({}, props));
        };
        WithMboxManifest.displayName = "WithMboxManifest(" + (Component.displayName || Component.name || "Component") + ")";
        return composeDataMethods(Component)(WithMboxManifest);
    };
};
export var useRouteMboxManifest = function(manifest) {
    /*
    manifest can be an object or a function or a promise that resolves to either
    if it's an object it should be a map of url patterns to mbox configurations
    if it's a function it should be a function that takes a url and returns an array of mbox configurations

    Object example:
    {
      "/": [
        {
          name: "mbox1",
          parameters: {
            foo: "bar",
          },
          profileParameters: {
            baz: "qux",
          },
        },
      ],
      "/p/*": [
        {
          name: "mbox2",
        },
      ],
      "regex:^/somepath$": [ ... ],
      "*": [ ... ],
    }

    Function example:
    (url) => {
      if (url === "/") {
        return [ ... ];
      }
      return [ ... ];
    }
  */ var url = useURL();
    // [ { name, parameters, profileParameters }, ...]
    var mboxes = useMemo(/*#__PURE__*/ _async_to_generator(function() {
        var resolveManifest, urlWithoutQuery, urlKeys;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!url) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        4,
                        manifest
                    ];
                case 1:
                    resolveManifest = _state.sent();
                    // Handle functions
                    if (typeof resolveManifest === "function") {
                        return [
                            2,
                            resolveManifest(url)
                        ];
                    }
                    // Handle objects
                    if (typeof resolveManifest === "object" && resolveManifest !== null) {
                        urlWithoutQuery = url.split("?")[0];
                        urlKeys = Object.keys(resolveManifest).filter(function(pattern) {
                            return urlMatch(pattern, urlWithoutQuery);
                        });
                        return [
                            2,
                            urlKeys.reduce(function(acc, key) {
                                return _to_consumable_array(acc).concat(_to_consumable_array(resolveManifest[key]));
                            }, [])
                        ];
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        manifest,
        url
    ]);
    useMboxManifest(mboxes);
};
export var withRouteMboxManifest = function(manifest) {
    return function(Component) {
        var WithRouteMboxManifest = function(props) {
            useRouteMboxManifest(manifest);
            return /*#__PURE__*/ _jsx(GlobalMboxes, {
                children: /*#__PURE__*/ _jsx(Component, _extends({}, props))
            });
        };
        WithRouteMboxManifest.displayName = "WithRouteMboxManifest(" + (Component.displayName || Component.name || "Component") + ")";
        return composeDataMethods(Component)(WithRouteMboxManifest);
    };
};
export var withRemoteRouteMboxManifest = function(fallbackManifest) {
    return function(Component) {
        var remoteManifest = getRemoteModule({
            remote: "abtFederationHost",
            module: "config"
        }).then(function(param) {
            var modPromise = param.module;
            return modPromise;
        }).then(function(factory) {
            return factory();
        }).then(function(config) {
            return config.default("manifest");
        }).catch(function(err) {
            if (!fallbackManifest) {
                // If there is no fallback manifest, we should throw the error
                throw err;
            }
            logger.error(new LapelError("" + err.message + " when trying to get remote mbox manifest, falling back to local manifest", {
                cause: err
            }));
            return fallbackManifest;
        });
        var WithRemoteRouteMboxManifest = function(props) {
            useRouteMboxManifest(remoteManifest);
            return /*#__PURE__*/ _jsx(GlobalMboxes, {
                children: /*#__PURE__*/ _jsx(Component, _extends({}, props))
            });
        };
        WithRemoteRouteMboxManifest.displayName = "WithRemoteRouteMboxManifest(" + (Component.displayName || Component.name || "Component") + ")";
        return composeDataMethods(Component)(WithRemoteRouteMboxManifest);
    };
};

//# sourceMappingURL=manifest.js.map